export const setParticipants = function (participantschools) {

	const participants = []

	participantschools.map((item) => {
		const { 
			schoolId,name,hasmenteam, haswomenteam,menteam, womenteam, mennonmember, womennonmember, 
			menTeamUSBCId,womenTeamUSBCId,menjv1team,menjv2team,womenjv1team,womenjv2team } = item

		participants.push({
			schoolId,
			schoolName:name,
			hasMenTeam:menteam, 
			hasWomenTeam:womenteam, 
			schoolHasMenTeam:hasmenteam ? hasmenteam:false, 
			schoolHasWomenTeam:haswomenteam ? haswomenteam:false, 
			hasMenNonMember:mennonmember ? mennonmember:false, 
			hasWomenNonMember:womennonmember ? womennonmember:false, 
			hasJV1MenTeam:menjv1team ? menjv1team:false,
			hasJV2MenTeam:menjv2team ? menjv2team:false,
			hasJV1WomenTeam:womenjv1team ? womenjv1team:false,
			hasJV2WomenTeam:womenjv2team ? womenjv2team:false,
			menTeamUSBCId,
			womenTeamUSBCId
		}) 
	})
	return participants
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Participants/Logic/setParticipants.js